// Centralized frontend configuration
//
// Priority:
// 1) REACT_APP_API_BASE_URL (recommended; works in dev + prod)
// 2) REACT_APP_API_BASE (legacy compatibility)
// 3) Localhost fallback: use CRA proxy in dev, or localhost:5000 for static local builds
// 4) Production fallback: hosted backend URL

const EXPLICIT_API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_BASE ||
  '';

const PROD_FALLBACK_API_BASE = 'https://lrbrain-backend-production.up.railway.app';

const LOCAL_STATIC_API_BASE = (() => {
  if (typeof window === 'undefined') return '';
  const host = window.location?.hostname;
  const port = window.location?.port;
  if ((host === 'localhost' || host === '127.0.0.1') && port && port !== '5000') {
    return 'http://localhost:5000';
  }
  return '';
})();

export const API_BASE = EXPLICIT_API_BASE ||
  LOCAL_STATIC_API_BASE ||
  (process.env.NODE_ENV === 'development' ? '' : PROD_FALLBACK_API_BASE);
